<template>
	<div class="mb_db learner_program_data">

		<div class="row">
      <div class="col-12">
        <template v-if="program">
          <div class="text-center prog-lmi">

						<div class="row">
							<div class="col-12 sub_hd_bar">
								<div class="sub_hd_ic">
									<div class="ic ic-icon_program"></div>
								</div>
								<div class="hd_txt">{{program.title}}</div>
							</div>
						</div>

						<div class="row thumbnail_sec">
							<div class="col-12 thumbnail">
								<img :src="program.thumbnailURL">
							</div>
						</div>

						<div class="row crd_content">
							<div class="col-12">

						    <div class="row sec_row">
	                <div class="col-6 sec_hd">US Data</div>
	                <div class="col-6">
										<span class="label">median income</span>
										<span class="val" v-if="program.medianIncomePerYear">
	                  	$<span v-html="addCommaInNumber(program.medianIncomePerYear)"></span>
										</span>
									</div>
	              </div>

	              <div class="row sec_row">
	                <div class="col-6">
										<span class="label">job postings</span>
	                	<span class="val" v-if="program.totalJobPostings">
	                  	<span v-html="addCommaInNumber(program.totalJobPostings)"></span>
	                	</span>
	                	<span class="no_val" v-else><strong>N/A</strong></span>
	              	</div>

									<div class="col-6">
										<span class="label">job growth</span>
		                <span class="val" v-if="program.growthRate">
		                  <span v-html="(Math.round(program.growthRate * 100) / 100).toFixed(1)"></span><span>%</span>
		                </span>
		                <span class="no_val" v-else><strong>N/A</strong></span>
		              </div>
								</div>

							</div>
						</div>

						<div class="row">
							<div class="col-12 lnk_container">
								<a href="javascript://" @click="navigateToCareerProspects">Career Prospects</a>
							</div>
						</div>

          </div>
        </template>
        <template v-else>
          <b-card class="text-center prog-lmi">

						<template #header>
							<div class="hd_ic">

							</div>
							<div class="hd_txt">

							</div>
						</template>

						<div class="crd_content">
	            <b-card-text>
	              <div class="mt-5">
	                <span>Program LMI data not available.</span>
	              </div>
	            </b-card-text>
						</div>

          </b-card>
        </template>
      </div>
    </div>

	</div>
</template>

<script>
	import { mapActions } from 'vuex'

	export default {
		name: 'learner-program-labor-data',
    props: ['program'],
		methods: {
			addCommaInNumber (numValue) {
        return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      navigateToCareerProspects () {
        let routerParams = {
          cipCode: this.program.cipCode,
          programGuideCode: this.program.code,
          type: this.program.type
        }
        return this.$router.push({name: 'programGuideCareerProspects', params: routerParams, query: {returnTo: 'learnerDashboard'}})
      }
		}
	}
</script>

<style scoped>
  .prog-lmi .card-header {
    height: 65px;
  }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerProgramLaborData.vue